import React, { forwardRef } from 'react';
import classNames from 'classnames/bind';
import styles from './Table.module.scss';

const cx = classNames.bind(styles);

function Table(props, ref) {
	const { type, children = '', caption = '', tableAlign = '', useHScroll = false, style = null } = props;
	return (
		<div
			className={cx({ scroll: useHScroll })}
			style={style}
		>
			<table
				ref={ref}
				className={cx('uitable', `uitable_${type}`, { [`cellalign_${tableAlign}`]: tableAlign !== '' })}
			>
				{caption !== '' && <caption>{caption}</caption>}
				{children}
			</table>
		</div>
	);
}

export default forwardRef(Table);

